import React, { useContext} from "react";
import "./Quotes.css";
import { searchClientAlgolia } from "../../firebase.config";
import { InstantSearch } from "react-instantsearch-hooks-web";
import QuotesBackendComponent from "./QuotesComponent";
import NoData from "../../NewComponents/NoData";
import { DataContext } from "../../Context/DataContext";

const QuotesBackend = ({ windowSize }) => {

  const { userData } = useContext(DataContext);

  if(!userData){
    return <NoData loading={true} showBtn={false} loadingText={"invoices"} type="quotes"/>
  }

  return (
    <>
      {/* <TopBar /> */}
    <InstantSearch searchClient={searchClientAlgolia} indexName="quotes" >
      <QuotesBackendComponent windowSize={windowSize}/>
      </InstantSearch>
    </>
  );
};

export default QuotesBackend;
